import { render, staticRenderFns } from "./WordInput.vue?vue&type=template&id=bf14a57e"
import script from "./WordInput.vue?vue&type=script&lang=js"
export * from "./WordInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports